import { render, staticRenderFns } from "./AgentMessage.vue?vue&type=template&id=0351d5d0&"
import script from "./AgentMessage.vue?vue&type=script&lang=js&"
export * from "./AgentMessage.vue?vue&type=script&lang=js&"
import style0 from "./AgentMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports